import { render, staticRenderFns } from "./TsAcademicYearFilter.vue?vue&type=template&id=4407f3ce&scoped=true&"
import script from "./TsAcademicYearFilter.vue?vue&type=script&lang=js&"
export * from "./TsAcademicYearFilter.vue?vue&type=script&lang=js&"
import style0 from "./TsAcademicYearFilter.vue?vue&type=style&index=0&id=4407f3ce&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407f3ce",
  null
  
)

export default component.exports